import { Container, Icon, Title } from "./styles";
import { useRouter } from "next/router";
import { useTranslation } from "@/lib/translations";

type Props = {
  handleClose: () => void;
};

const Header: React.FC<Props> = (props) => {
  const { handleClose } = props;
  const { locale = "it" } = useRouter();
  const label = useTranslation("productListing.filtersButton", locale) || "";
  return (
    <Container>
      <Title>{label}</Title>
      <Icon onClick={() => handleClose()} />
    </Container>
  );
};

export default Header;
